import { render } from "./CommissionsDashboard.vue?vue&type=template&id=4acded0c"
import script from "./CommissionsDashboard.vue?vue&type=script&lang=js"
export * from "./CommissionsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__